import React, { useState, useEffect } from "react";
import Srcset from "./Srcset";
import styles from "../../components/ProductDetailsComp/Sections/sections.module.scss"
import { useSelector } from "react-redux";
const Accordion = ({ PlusIcon, data,dataTwo, defaultOpen = false  }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState([]);
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  const handleClick = (ele) => {
    let newArr = [...active];
    const sizeGuidePopup = (typeof document !== 'undefined') ? document.querySelector('.size-guide-popup') : null;

    if (active.includes(ele) && !sizeGuidePopup) {
      setActive(newArr.filter((e) => e !== ele));
    } else {
      setActive([...newArr, ele]);
    }
  };
  useEffect(() => { // code to set the first dropdown open in mobile for PDP based on defaultOpen
    if (defaultOpen && data && data.length > 0) {
      setActive([data[0]]);
    }
  }, [defaultOpen, data]);

  // to open accordion and scroll to brand section
  const handleScrollToBrand = () => {
    if(typeof document !== "undefined") {
      const brandSection = document.querySelector(".shipping_vendor_sub_block");
      const yOffset = isPWA ? -150 : -105; // Adjust this based on your header height
      if (brandSection) {
        const y = brandSection.getBoundingClientRect()?.top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }

  return (
    <div className="typography-wrap">
      <div className="custom-accordion">
        {data?.map((ele, i) => (
          <div
            key={i}
            className={`accordion-item ${active.includes(ele) && "open"} ${ele?.headerClass}`}
            onClick={() => {handleClick(ele);}}
          >
            <div className={`accordion-head ${ele.subTitle?"accordian_pdp_date":""}`}>
              <span className="name pdp-ga4-click-trigger" data-pdpGa4={ele?.ga4Data}>{ele?.title}</span>
              <span className="right">
                <Srcset
                  height={14}
                  width={14}
                  alt="down arrow"
                  requirePath={true}
                  svgFile={true}
                  src={ele?.icon?.src}
                  lazyLoad={true}
                  data-pdpGa4={ele?.ga4Data}
                  className={`pdp-ga4-click-trigger ${
                    active.includes(ele) && ele?.icon?.animationClass
                  }`}
                />
              </span>
              <span className={`x-small-xs ${styles.pdp_date_text} italic`}>{ele.subTitle && (!active.includes(ele) && ele?.hideSubTitle) && ele.subTitle}</span>
              {ele.subTitle2 && (!active.includes(ele) && ele?.hideSubTitle) ? <span className={`x-small-xs italic ${styles.pdp_date_text}`}>Shipped By&nbsp;
                <a onClick={(e) => {
                  e.preventDefault();
                  handleScrollToBrand();
                }} className="ga-pdp-shipping-vendor">{ele.subTitle2}</a></span> : null}
            </div>
            <div className="accordion-body">{ele?.body}</div>
          </div>
        ))}
        {dataTwo?.map((ele, i) => (
          <div
            key={i}
            className={`accordion-item ${active.includes(ele) && "open"}`}
            onClick={() => handleClick(ele)}
          >
            <div className="accordion-head">
              <span className="name">{ele?.title}</span>
              <span className="right">
                <Srcset
                  height={14}
                  width={14}
                  alt="down arrow"
                  requirePath={true}
                  svgFile={true}
                  src={ele?.icon?.src}
                  lazyLoad={true}
                  className={`${
                    active.includes(ele) && ele?.icon?.animationClass
                  }`}
                />
              </span>
            </div>
            <div className="accordion-body">{ele?.body}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Accordion;
